import { useContent } from "@/context/ContentContext";
import { Nav } from "@/components/td/Nav";
import { Hero } from "@/components/td/Hero";
import { Marquee } from "@/components/td/Marquee";
import { Manifiesto } from "@/components/td/Manifiesto";
import { BleedQuote } from "@/components/td/BleedQuote";
import { Servicios } from "@/components/td/Servicios";
import { ParaQuien } from "@/components/td/ParaQuien";
import { Casos } from "@/components/td/Casos";
import { PorQue } from "@/components/td/PorQue";
import { BleedRoles } from "@/components/td/BleedRoles";
import { Contacto } from "@/components/td/Contacto";
import { Footer } from "@/components/td/Footer";

export default function Landing() {
  const { cinta } = useContent();

  return (
    <div className="td">
      <Nav />
      <main>
        <Hero />
        <Marquee items={cinta?.items || []} className="bl" testid="cinta-marquee" />
        <Manifiesto />
        <BleedQuote />
        <Servicios />
        <ParaQuien />
        <Casos />
        <PorQue />
        <BleedRoles />
        <Contacto />
      </main>
      <Footer />
    </div>
  );
}
